module.exports = __webpack_public_path__ + "img/qu_ch.8d0f3e4.jpg";